/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../../resetter/resetable';
import { DynForm } from 'src/app/_model/dyn-form';

@Injectable()
export abstract class DynFormsDaoService implements Resetable {
  public abstract saveDynForms(dynForms: DynForm[]): Promise<void>;
  public abstract getDynForms(): Promise<DynForm[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
